/**
 * Daily login reward API. Both calls carry the session JWT: the reward is paid to the signed-in
 * account, so a signed-out visitor never sees the popup.
 */
import { API_BASE_URL } from '../config/apiConfig';
import { getSession } from '../auth/sessionStore';

const API_VERSION = 'v1';
const API_BASE_PATH = '/api';

function withBase(path: string): string {
  return `${API_BASE_URL}${API_BASE_PATH}/${API_VERSION}${path}`;
}

function authHeaders(): Record<string, string> {
  const token = getSession()?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface DailyLoginStatus {
  success: boolean;
  canClaim?: boolean;
  day?: number;
  rewards?: number[];
  streakLength?: number;
  error?: string;
}

export interface DailyLoginClaim {
  success: boolean;
  claimed?: boolean;
  day?: number;
  reward?: number;
  suikaBalance?: number;
  error?: string;
}

export async function fetchDailyLoginStatus(): Promise<DailyLoginStatus> {
  const response = await fetch(withBase('/daily-login/status'), { headers: authHeaders() });
  return (await response.json()) as DailyLoginStatus;
}

export async function claimDailyLoginReward(): Promise<DailyLoginClaim> {
  const response = await fetch(withBase('/daily-login/claim'), { method: 'POST', headers: authHeaders() });
  return (await response.json()) as DailyLoginClaim;
}
